import { NatsConnection, connect, jwtAuthenticator } from 'nats.ws';

import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';

import { User } from '../stores/UserStore/UserStore.types';


const pingInterval = 30;
const retryDelayMultiplier = 20;
const maxRetryDelay = 120;
let retryAttempt = 0;

const reconnectDelayHandler = () => {
  retryAttempt += 1;

  const delay = Math.min(retryAttempt * retryDelayMultiplier, maxRetryDelay);

  // eslint-disable-next-line no-console
  console.info(`Connection attempt #${retryAttempt} after ${delay}s`);

  return delay * SECOND_AS_MILLISECONDS;
};


export async function getNats(user: User): Promise<NatsConnection | void> {
  const server = ConfigurationService.get(ConfigurationKeys.NATS_URL) as string;
  const jwt = user.natsJWT;

  if (!server || !jwt) {
    return undefined;
  }

  const authenticator = jwtAuthenticator(jwt);
  let connection = undefined;


  try {
    connection = await connect({
      name: `${user.userId}`,
      servers: [server],
      authenticator,
      reconnect: true,
      reconnectTimeWait: retryDelayMultiplier,
      maxReconnectAttempts: 10,
      pingInterval: pingInterval * SECOND_AS_MILLISECONDS,
    });

    retryAttempt = 0;

  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error connecting to NATS', error);
  }

  if (connection) {
    return connection;
  }

  return new Promise((res) => {
    setTimeout(async() => {
      const nextConnection = await getNats(user);

      res(nextConnection);
    }, reconnectDelayHandler());
  });
}
